import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class CustomGestureConfigService extends HammerGestureConfig {
  /**
   * Build hammer from HTMLElement. Returns proxy object overriding on/off method.
   * @param element
   */
  override buildHammer( element: HTMLElement ) {
    let mc = new (<any> window).Hammer(element);

    for (let eventName in this.overrides) {
      mc.get(eventName).set(this.overrides[eventName]);
    }

    return {
      on: ( eventName: string, callback: Function ) => {
        return mc.on( eventName, callback );
      },
      off: ( eventName: string, callback: Function ) => {
        const omc = mc.off( eventName, callback );
        //Manually calling destroy
        if (typeof omc.destroy === 'function') {
          omc.destroy();
        }

        return omc;
      }
    };
  }
}
